import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CPlusPlus from '../svg/C++';
import Java from '../svg/Java';
import DotNet from '../svg/DotNet';
import NodeJS from '../svg/NodeJS';
import Python from '../svg/Python';
import Ruby from '../svg/Ruby';
import Groovy from '../svg/Groovy';
import Spring from '../svg/Spring';
import JavaScript from '../svg/JavaScript';
import ReactJS from '../svg/ReactJS';
import AngularJS from '../svg/AngularJS';
import TypeScript from '../svg/TypeScript';
import VueJS from '../svg/VueJS';
import Redux from '../svg/Redux';
import Flutter from '../svg/Flutter';
import Ionic from '../svg/Ionic';
import GraphQL from '../svg/GraphQL';
import NextJS from '../svg/NextJS';
import Kotlin from '../svg/Kotlin';
import Swift from '../svg/Swift';
import Meteor from '../svg/Meteor';

export default function SimpleSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    nextArrow: null,
    prevArrow: null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };
  
  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-6xl">
        <Slider {...settings}>
          <div className="flex justify-center items-center px-4">
            <Java size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <DotNet size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <NodeJS size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Python size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <CPlusPlus size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Ruby size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Spring size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <JavaScript size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Meteor size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <TypeScript size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <GraphQL size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <NextJS size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <ReactJS size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <AngularJS size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <VueJS size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Redux size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Flutter size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Ionic size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Swift size={80} />
          </div>
          <div className="flex justify-center items-center px-4">
            <Kotlin size={80} />
          </div>
        </Slider>
      </div>
    </div>
  );
}
